export default "__VITE_ASSET__wQtCAo7h__"